// LabsPage.jsx - نسخه نهایی، بدون دبل‌کلیک
import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Search, Phone, Home } from 'lucide-react';
import persianDate from 'persian-date';

function LabCard({ lab, index }) {
  const phones = lab.phone.split(',').map(p => p.trim()).filter(Boolean);

  return (
    <div
      className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 transition-all duration-200 hover:shadow-xl hover:-translate-y-1"
      style={{ touchAction: 'manipulation' }}
    >
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-xl font-bold text-gray-800">{lab.name}</h3>
        <Phone className="w-5 h-5 text-indigo-500" />
      </div>

      <div className="flex flex-wrap gap-2">
        {phones.map((num, i) => (
          <a
  key={i}
  href={`tel:${num.replace(/[^0-9+]/g, '')}`}
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-1 bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-3 py-1.5 rounded-full text-sm font-medium transition-shadow hover:shadow-md select-none"
  style={{ touchAction: 'manipulation' }}
>
  <Phone className="w-3 h-3" />
  {num}
</a>
        ))}
      </div>
    </div>
  );
}

export default function LabsPage() {
  const [labsData, setLabsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLabs = async () => {
      try {
        setLoading(true);
        const response = await fetch('/labs.csv?t=' + Date.now());
        const text = await response.text();
        const lines = text.trim().split('\n').slice(1);
        const labs = lines
          .map(line => {
            const [name, ...phoneParts] = line.split(',').map(s => s.trim().replace(/^"|"$/g, ''));
            const phone = phoneParts.join(', ');
            return { name, phone };
          })
          .filter(lab => lab.name && lab.phone);
        setLabsData(labs);
      } catch (err) {
        console.error('خطا در بارگذاری labs.csv', err);
        setLabsData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchLabs();
  }, []);

  const filteredLabs = useMemo(() => {
    if (!labsData.length) return [];
    return labsData.filter(lab =>
      lab.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lab.phone.includes(searchTerm)
    );
  }, [labsData, searchTerm]);

  const today = new persianDate().format('dddd DD MMMM YYYY');

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50">
        <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 p-4 md:p-6 font-vazir">
      {/* هدر */}
      <div className="bg-white/80 rounded-3xl shadow-xl p-6 md:p-8 mb-6 border border-white/30">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800">آزمایشگاه‌های ری‌گیری طلا</h1>
            <p className="mt-2 text-lg text-gray-600">لیست کامل در سراسر ایران • {filteredLabs.length} مورد</p>
            <p className="text-sm text-gray-500 mt-1">به‌روزرسانی: {today}</p>
          </div>

          <Link
            to="/"
            className="p-3 rounded-full bg-indigo-500 text-white hover:bg-indigo-600 transition-colors z-50"
            style={{ touchAction: 'manipulation' }}
          >
            <Home className="w-5 h-5" />
          </Link>
        </div>
      </div>

      {/* جستجو */}
      <div className="bg-white/80 rounded-3xl shadow-xl p-4 mb-6 border border-white/30">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="جستجو در نام یا شماره تلفن..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-500 focus:outline-none transition-colors text-base"
            style={{ touchAction: 'manipulation' }}
          />
        </div>
      </div>

      {/* لیست کارت‌ها */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredLabs.map((lab, index) => (
          <LabCard key={`${lab.name}-${index}`} lab={lab} index={index} />
        ))}
      </div>

      {filteredLabs.length === 0 && (
        <div className="col-span-full text-center py-16 text-gray-500">
          <Search className="w-16 h-16 mx-auto mb-4 opacity-50" />
          <p className="text-lg">هیچ آزمایشی پیدا نشد.</p>
        </div>
      )}

      {/* فوتر */}
      <div className="text-center mt-16 text-sm text-gray-500 bg-white/60 rounded-2xl p-4 border border-white/30">
        <p>© {new persianDate().format('YYYY')} ESF Gold</p>
        <p className="mt-1">منبع: منابع عمومی • به‌روزرسانی خودکار</p>
      </div>
    </div>
  );
}